export interface AreaOfStudy {
  id: number
  name: string
  headline: string
  description: string
  careerOutlook: string
  salaryRange: string
  jobTitles: string[]
  whyStudy: string
  whatToLookFor: string
}

export const areaOfStudyData: Record<number, AreaOfStudy> = {
  1: {
    id: 1,
    name: 'Business & Finance',
    headline:
      'Top Accredited Online Business & Finance Degree Programs of 2026',
    description:
      'Earn a business degree at your own pace and open doors to leadership roles in corporate, non-profit, and entrepreneurial settings.',
    careerOutlook:
      'Employment in business and financial operations occupations is projected to grow faster than average, adding about 715,100 new jobs over the next decade.',
    salaryRange: '$60,000 - $120,000+',
    jobTitles: [
      'Financial Analyst',
      'Marketing Manager',
      'Human Resources Specialist',
      'Accountant',
      'Operations Manager',
    ],
    whyStudy:
      "A business degree provides versatile skills applicable to nearly every industry. You'll learn critical thinking, leadership, and financial management.",
    whatToLookFor:
      'Look for AACSB or ACBSP accreditation, flexible scheduling, and programs that offer specializations aligned with your career goals.',
  },
  2: {
    id: 2,
    name: 'Criminal Justice & Legal Services',
    headline: 'Top Accredited Online Criminal Justice Degree Programs of 2026',
    description:
      'Prepare for a rewarding career in law enforcement, corrections, or legal services with a flexible online degree.',
    careerOutlook:
      'Steady demand for police and detectives, with growing opportunities in specialized fields like cybercrime and forensic science.',
    salaryRange: '$50,000 - $90,000+',
    jobTitles: [
      'Police Officer',
      'Probation Officer',
      'Paralegal',
      'Private Investigator',
      'Intelligence Analyst',
    ],
    whyStudy:
      'Make a tangible difference in your community while enjoying job stability and diverse career paths in local, state, or federal agencies.',
    whatToLookFor:
      'Programs with experienced faculty from the field, strong alumni networks, and curriculum covering modern challenges like digital forensics.',
  },
  3: {
    id: 3,
    name: 'Psychology & Counseling',
    headline: 'Top Accredited Online Psychology Degree Programs of 2026',
    description:
      'Explore online psychology degree programs from accredited online psychology colleges and universities. Prepare for rewarding careers in counseling, human resources, research, or social services with a flexible online psychology degree.',
    careerOutlook:
      'Overall employment of psychologists is projected to grow 6 percent, with high demand for clinical and counseling psychologists. Graduates of online psychology schools and online psychology universities are well-positioned for these growing roles.',
    salaryRange: '$45,000 - $85,000+',
    jobTitles: [
      'Substance Abuse Counselor',
      'Human Resources Specialist',
      'Market Research Analyst',
      'Social Worker (with further education)',
    ],
    whyStudy:
      'An online psychology degree program gives you deep insights into the human mind while building communication and analytical skills that are highly valued across professions. Online psychology colleges and online psychology universities offer flexible schedules so you can earn your degree without putting your life on hold.',
    whatToLookFor:
      'When comparing online psychology schools, prioritize APA accreditation (for graduate programs), research opportunities, and coursework aligned with your interests like child development or organizational psychology. The best online psychology colleges also offer practicum placements and strong faculty mentorship.',
  },
  4: {
    id: 4,
    name: 'Computers & Technology',
    headline: 'Top Accredited Online Computer Science Degree Programs of 2026',
    description:
      'Enter the fast-growing tech industry with a degree in computer science, IT, or cybersecurity.',
    careerOutlook:
      'Employment in computer and IT occupations is projected to grow 15 percent, much faster than the average for all occupations.',
    salaryRange: '$70,000 - $130,000+',
    jobTitles: [
      'Software Developer',
      'Cybersecurity Analyst',
      'IT Manager',
      'Data Scientist',
      'Network Administrator',
    ],
    whyStudy:
      'Technology is at the core of modern business. A tech degree offers high earning potential, job security, and the ability to work remotely.',
    whatToLookFor:
      'Up-to-date curriculum covering modern languages (Python, Java) and concepts (Cloud, AI), hands-on projects, and industry certifications.',
  },
  5: {
    id: 5,
    name: 'Healthcare & Medical Assisting',
    headline:
      'Top Accredited Online Healthcare Administration Degree Programs of 2026',
    description:
      'Join the booming healthcare sector in administrative, management, or support roles.',
    careerOutlook:
      'Employment of medical and health services managers is projected to grow 28 percent, much faster than average.',
    salaryRange: '$55,000 - $105,000+',
    jobTitles: [
      'Healthcare Administrator',
      'Medical Records Manager',
      'Clinical Director',
      'Public Health Educator',
    ],
    whyStudy:
      'Healthcare is one of the fastest-growing industries. You can make a significant impact on patient care without necessarily being a clinical practitioner.',
    whatToLookFor:
      'CAHME accreditation (for admin), practicum opportunities, and courses on healthcare law, ethics, and informatics.',
  },
  6: {
    id: 6,
    name: 'Education & Teaching',
    headline: 'Top Accredited Online Education Degree Programs of 2026',
    description:
      'Shape the future by becoming a certified teacher, instructional coordinator, or educational administrator.',
    careerOutlook:
      'Steady demand for teachers, particularly in special education, STEM fields, and bilingual education.',
    salaryRange: '$45,000 - $75,000+',
    jobTitles: [
      'Elementary School Teacher',
      'High School Teacher',
      'Instructional Coordinator',
      'Special Education Teacher',
    ],
    whyStudy:
      'Teaching is a deeply rewarding profession that allows you to inspire the next generation and enjoy a schedule aligned with the school year.',
    whatToLookFor:
      'CAEP accreditation, programs that lead to licensure in your state, and robust student-teaching placement support.',
  },
  7: {
    id: 7,
    name: 'Trade, Vocational, Career',
    headline:
      'Top Accredited Online Vocational & Career Degree Programs of 2026',
    description:
      'Gain practical, job-ready skills for specialized careers in various trades and technical fields.',
    careerOutlook:
      'Strong demand for skilled tradespeople and technicians as older workers retire and infrastructure needs grow.',
    salaryRange: '$40,000 - $80,000+',
    jobTitles: [
      'Construction Manager',
      'HVAC Technician',
      'Electrician',
      'Automotive Service Technician',
    ],
    whyStudy:
      'Enter the workforce quickly with specialized skills that are in high demand and often resistant to outsourcing or automation.',
    whatToLookFor:
      'Industry-recognized certifications, hands-on training components, and strong job placement rates.',
  },
  8: {
    id: 8,
    name: 'Liberal Arts',
    headline: 'Top Accredited Online Liberal Arts Degree Programs of 2026',
    description:
      'Develop broad intellectual capacities, critical thinking, and communication skills applicable to diverse careers.',
    careerOutlook:
      'Liberal arts graduates find success in a wide range of fields, from media and communications to business and government.',
    salaryRange: '$45,000 - $85,000+',
    jobTitles: [
      'Public Relations Specialist',
      'Writer/Editor',
      'Sales Manager',
      'Event Planner',
      'Non-profit Director',
    ],
    whyStudy:
      'A liberal arts education teaches you how to think, not just what to think, making you adaptable in a rapidly changing job market.',
    whatToLookFor:
      'Flexible curriculum allowing you to explore multiple disciplines, strong writing and research components, and internship opportunities.',
  },
  9: {
    id: 9,
    name: 'General',
    headline: 'Top Accredited Online College Degree Programs of 2026',
    description:
      'Design a customized degree program that fits your unique career goals and interests.',
    careerOutlook:
      'Highly variable depending on the specific courses chosen, but generally provides a solid foundation for many entry-level professional roles.',
    salaryRange: '$40,000 - $75,000+',
    jobTitles: [
      'Administrative Services Manager',
      'Customer Success Manager',
      'Project Coordinator',
      'Sales Representative',
    ],
    whyStudy:
      "Perfect for students with diverse interests or those who have accumulated credits in various subjects and want to complete a bachelor's degree efficiently.",
    whatToLookFor:
      'Generous transfer credit policies, academic advising to help structure your degree, and a wide variety of elective options.',
  },
  10: {
    id: 10,
    name: 'Nursing',
    headline:
      'Top Accredited Online Nursing (RN to BSN) Degree Programs of 2026',
    description:
      'Advance your nursing career, increase your earning potential, and improve patient outcomes with a BSN.',
    careerOutlook:
      'Employment of registered nurses is projected to grow 6 percent, with strong preference for BSN-prepared nurses by many employers.',
    salaryRange: '$70,000 - $110,000+',
    jobTitles: [
      'Registered Nurse (BSN)',
      'Nurse Manager',
      'Clinical Nurse Leader',
      'Public Health Nurse',
    ],
    whyStudy:
      'A BSN opens doors to leadership roles, specialized clinical positions, and is often a stepping stone to advanced practice nursing (MSN/DNP).',
    whatToLookFor:
      'CCNE or ACEN accreditation, flexible clinical requirements that can be completed locally, and strong NCLEX pass rates (if applicable).',
  },
  11: {
    id: 11,
    name: 'Media & Communications',
    headline: 'Top Accredited Online Communications Programs of 2026',
    description:
      'Master the art of messaging for careers in public relations, journalism, marketing, and digital media.',
    careerOutlook:
      'Employment in media and communication occupations is projected to grow 14 percent, driven by the need to create, edit, and disseminate information.',
    salaryRange: '$50,000 - $95,000+',
    jobTitles: [
      'Public Relations Specialist',
      'Social Media Manager',
      'Technical Writer',
      'Journalist',
      'Marketing Coordinator',
    ],
    whyStudy:
      "Strong communication skills are universally valued. You'll learn to craft compelling narratives across various platforms and media.",
    whatToLookFor:
      'Programs offering hands-on experience with modern digital tools, opportunities to build a portfolio, and faculty with industry experience.',
  },
  12: {
    id: 12,
    name: 'Visual Arts & Graphic Design',
    headline: 'Top Accredited Online Graphic Design Programs of 2026',
    description:
      'Turn your creativity into a career by learning design principles, digital tools, and visual communication.',
    careerOutlook:
      'Steady demand for designers in digital spaces, including web design, UX/UI, and digital marketing.',
    salaryRange: '$45,000 - $85,000+',
    jobTitles: [
      'Graphic Designer',
      'UX/UI Designer',
      'Art Director',
      'Web Designer',
      'Animator',
    ],
    whyStudy:
      'Combine artistic talent with technical skills to create visual concepts that inspire, inform, and captivate consumers.',
    whatToLookFor:
      'Access to industry-standard software (Adobe Creative Cloud), strong portfolio development focus, and critiques from experienced professionals.',
  },
  13: {
    id: 13,
    name: 'Religious Studies',
    headline: 'Top Accredited Online Religious Studies Programs of 2026',
    description:
      'Explore the history, beliefs, and practices of world religions and prepare for roles in ministry, education, or non-profits.',
    careerOutlook:
      'Opportunities exist in clergy, religious education, counseling, and various roles within faith-based organizations and NGOs.',
    salaryRange: '$40,000 - $70,000+',
    jobTitles: [
      'Clergy/Minister',
      'Religious Educator',
      'Non-profit Director',
      'Chaplain',
      'Community Service Manager',
    ],
    whyStudy:
      'Gain a profound understanding of human culture, ethics, and spirituality, while developing strong analytical and communication skills.',
    whatToLookFor:
      'Accreditation by recognized theological associations (if applicable), diverse course offerings, and opportunities for practical ministry or service.',
  },
}

export const areaOfStudyOptions = Object.values(areaOfStudyData).map(
  (area) => ({
    value: area.id,
    label: area.name,
  }),
)
